import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import About from "./pages/About";
import Remedy from "./pages/Remedy";
import Contact from "./pages/Contact";

const SmoothScroll = () => {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);
    return null;
};

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <BrowserRouter>
            <SmoothScroll />
            <ScrollToTop />
            <div className="min-h-screen bg-[#060a07] text-[#f3fbf5]">
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/remedy" element={<Remedy />} />
                    <Route path="/contact" element={<Contact />} />
                </Routes>
                <Footer />
                <WhatsAppButton />
            </div>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0b150e",
                        border: "1px solid rgba(34,197,94,0.3)",
                        color: "#f3fbf5",
                    },
                }}
            />
        </BrowserRouter>
    );
}

export default App;
